module.exports = __webpack_public_path__ + "static/keyboardshortcut-result-do-23fdebaacc285dc877422d81d00551ea.png";